export default __webpack_public_path__ + "static/media/limb_small.f1156b08.webp";